<template>
    <div
        class="group"
        @click="emits('close')"
        @mouseenter="emits('open')"
        @mouseleave="emits('close')">
        <component
            :is="labelLink ? 'div' : 'button'"
            :type="labelLink ? undefined : 'button'"
            :class="{
                'text-accent': isOpen,
            }"
            class="relative flex items-center transition-all duration-300">
            <div
                :class="{
                    'rounded-t-md opacity-0': !isOpen,
                    'rounded-t-20': isOpen,
                }"
                class="absolute -inset-x-4 -top-5 h-[4.75rem] w-[calc(100%_+_1rem)] bg-white transition-all duration-300">
                <AtomIcon
                    name="chevron-down"
                    class="absolute bottom-3 left-1/2 size-2.5 -translate-x-1/2 text-accent" />
                <AtomIcon
                    v-if="chevronRight"
                    name="inner-rounded-corner"
                    class="absolute -right-2 bottom-0 size-2 rotate-90" />
                <AtomIcon
                    v-if="chevronLeft"
                    name="inner-rounded-corner"
                    class="absolute -bottom-0 -left-2 size-2" />
            </div>
            <NuxtLink
                v-if="labelLink"
                :to="labelLink"
                class="relative font-semibold">
                {{ label }}
            </NuxtLink>
            <span
                v-else
                class="relative font-semibold">
                {{ label }}
            </span>
            <AtomIcon
                name="chevron-down"
                :class="{
                    'opacity-100': !isOpen,
                }"
                class="ml-2 size-2.5 opacity-0 transition-all duration-300" />
        </component>
        <div
            :class="[
                {
                    'opacity-100': isOpen,
                    'pointer-events-none': !isOpen,
                },
                dropdownClass,
            ]"
            class="absolute overflow-hidden bg-white opacity-0 transition-all duration-300">
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'

interface Props {
    isOpen: boolean
    label: string
    labelLink?: string
    chevronLeft?: boolean
    chevronRight?: boolean
    dropdownClass?: string
}
interface Emits {
    (e: 'open' | 'close'): void
}

defineProps<Props>()
const emits = defineEmits<Emits>()
</script>
